import toggleAttachment from './common/toggle-attachment'
import updateAccountGroupInput from './common/update-account-group-input'
import updateAttachmentGroupInput from './common/update-attachment-group-input'
import updateInputsInOtherGroups from './common/update-inputs-in-other-groups'
import updateAccountMasterGroupInput from '@app/application/export/behaviors/export-form-tools/widgets/account/common/update-account-master-group-input'

function updateUI() {
  const $this = $(this)

  toggleAttachment($this)
  updateInputsInOtherGroups($this)
  updateAttachmentGroupInput($this.closest('table'))
  updateAccountGroupInput($this.closest('table'))
  updateAccountMasterGroupInput($this.closest('.check-master-group'))
}

export default () => {
  $(document).on(
    'change',
    '[data-behaviour="export-check-account-or-text"]',
    updateUI
  )

  return () =>
    $(document).off(
      'change',
      '[data-behaviour="export-check-account-or-text"]',
      updateUI
    )
}
